import { trpc } from "../lib/api/trpc";

export type UserRole = "ADMIN" | "MANAGER" | "SUPERVISOR" | "SERVER" | "USER";

export const usePermissions = () => {
  // @ts-ignore - tRPC type issues
  const { data: user } = trpc.auth.me.useQuery();

  const userRole = user?.role as UserRole;

  console.log("usePermissions: user role is", userRole);

  // Individual role checks
  const isAdmin = userRole === "ADMIN";
  const isManager = userRole === "MANAGER";
  const isSupervisor = userRole === "SUPERVISOR";
  const isServer = userRole === "SERVER";
  const isUser = userRole === "USER";

  // Grouped permission checks
  const isManagerOrAbove = ["ADMIN", "MANAGER"].includes(userRole);
  const isStaffMember = ["SUPERVISOR", "SERVER", "USER"].includes(userRole);

  // Permission checker function
  const hasAccess = (allowedRoles: UserRole[]): boolean => {
    if (!userRole) return false;
    return allowedRoles.includes(userRole);
  };

  // Cash-out specific permissions
  const cashOutPermissions = {
    canViewAll: isManagerOrAbove, // Only managers and above can view all
    canEditAll: isManagerOrAbove, // Only managers and above can edit all
    canEditOwn: true, // Everyone can edit their own
    canApprove: isManagerOrAbove, // Only managers and above can approve
    canExportCSV: isManagerOrAbove, // Only managers and above can export
    canCreate: true, // Everyone can create their own cash out
    canViewOwn: true, // Everyone can view their own
  };

  return {
    userRole,
    isAdmin,
    isManager,
    isSupervisor,
    isServer,
    isUser,
    isManagerOrAbove,
    isStaffMember,
    hasAccess,
    cashOutPermissions,
    isLoading: !user,
  };
};
